<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 21 21"
>
  <rect
    fill="none"
    height="100%"
    stroke="none"
    width="100%"
    x="0"
    y="0"
  />
  <path
    d="M1.79599 14.9782L8.94625 2.94758C9.72883 1.63086 11.6405 1.64655 12.4013 2.97595L19.2868 15.0065C20.0499 16.3399 19.0872 18 17.551 18H3.51525C1.96439 18 1.00363 16.3113 1.79599 14.9782Z"
    stroke="#FF9900"
  />
  <path
    d="M9.888 13.668V15H11.22V13.668H9.888ZM11.124 9.072V6.432H9.984V9.072L10.284 12.804H10.824L11.124 9.072Z"
    fill="#FF9900"
  />
</svg>
